import React, { useState } from "react";
// componentes
import { Modal, ModalBody, ModalHeader, Col, Row, Button } from "reactstrap";
import ButtonSpinner from "../../../components/Buttons/ButtonSpinner";
// alerta
import SweetAlert from "react-bootstrap-sweetalert";
// redux
import { connect } from "react-redux";
// service
import { updateFeed } from "../../../utils/services/feed";
import { getUrlFiles } from "../../../utils/services/files";

function EditFeed(props) {
  const { isOpen, toggle } = props;
  const [modalBackdrop, setModalBackdrop] = useState(false);
  // dados do form
  const [texto, setTexto] = useState(props.feedEdit.text);
  const [isVisible, setIsVisible] = useState(
    props.feedEdit.active ? true : false,
  );
  const [isFixed, setIsFixed] = useState(props.feedEdit.fixed ? true : false);
  //imagem
  const [imageView, setImageView] = useState(props.feedEdit.url);
  const [newImage, setNewImage] = useState(null);
  //confirmação
  const [successDlg, setSuccessDlg] = useState(false);
  const [submitErrorMessage, setSubmitErrorMessage] = useState("");
  const [imageErro, setImageErro] = useState("");
  const [isLoading, setIsLoading] = useState(false);

  // alterna o backdrop do modal
  function toggleBackdrop() {
    setModalBackdrop(!modalBackdrop);
  }

  // lê o arquivo de imagem selecionado e atualiza o preview
  const onImageChange = (event) => {
    if (event.target.files && event.target.files[0]) {
      setNewImage({ files: event.target.files });

      let reader = new FileReader();
      reader.onload = (e) => {
        setImageView(e.target.result);
      };
      reader.readAsDataURL(event.target.files[0]);
    }
  };

  // valida o form, envia a nova imagem (se houver) e atualiza o post
  async function submitForm(e) {
    e.preventDefault();

    if (!texto && !imageView) {
      setImageErro("Selecione um texto ou uma imagem.");
      return;
    } else setImageErro("");

    let urlImg = props.feedEdit.url;
    let expireDate = props.feedEdit.expireDate;

    if (newImage) {
      const data = new FormData();
      data.append("files", newImage.files[0]);
      data.append("folder", "feed");
      data.append("eventId", props.idEvent);

      try {
        const response = await getUrlFiles(
          data,
          props.state.global_user_data.data.token,
        );
        response.forEach((file) => {
          urlImg = file.url;
          expireDate = file.expires;
        });
      } catch (error) {
        console.error("Erro ao enviar a imagem:", error);
        setSubmitErrorMessage("Erro ao enviar a imagem.");
        return;
      }
    }

    const dataPost = {
      eventid: props.idEvent,
      title: "",
      text: texto,
      url: urlImg,
      active: isVisible,
      fixed: isFixed,
      date: new Date(),
      postsource: null,
      postid: props.feedEdit.id,
      expireDate: expireDate,
    };

    setIsLoading(true);
    try {
      const feedData = await updateFeed(
        dataPost,
        props.state.global_user_data.data.token,
      );
      if (feedData.message === "updated") {
        setSuccessDlg(true);
      }
    } catch (error) {
      console.error("Erro ao atualizar o post:", error);
      setSubmitErrorMessage("Erro ao atualizar o post.");
    } finally {
      setIsLoading(false);
    }
  }

  return (
    <Modal
      isOpen={isOpen}
      toggle={() => {
        toggleBackdrop();
      }}
      autoFocus={true}
      centered={true}
    >
      {successDlg ? (
        <SweetAlert
          success
          title={"Editado"}
          onConfirm={() => {
            props.getAllFeed();
            setSuccessDlg(false);
            toggle();
          }}
        >
          {"Post editado com sucesso!"}
        </SweetAlert>
      ) : null}
      {submitErrorMessage && (
        <SweetAlert
          danger
          title={"Erro"}
          onConfirm={() => setSubmitErrorMessage("")}
        >
          {submitErrorMessage}
        </SweetAlert>
      )}
      <ModalHeader toggle={toggle}>Editar Post</ModalHeader>
      <ModalBody>
        <form onSubmit={submitForm}>
          <Row>
            <Col lg={12}>
              <div>
                <label className="form-label">ID do Post</label>
                <input
                  className="form-control"
                  type="text"
                  defaultValue={props.feedEdit.id}
                  disabled
                />
              </div>
            </Col>
          </Row>

          <Row>
            <Col lg={12}>
              <div>
                <label className="form-label">Texto</label>
                <input
                  className="form-control"
                  type="text"
                  value={texto}
                  onChange={(e) => setTexto(e.target.value)}
                />
              </div>
            </Col>
          </Row>

          <Row style={{ marginTop: 20 }}>
            <Col sm={6} style={{ display: "flex", alignItems: "center" }}>
              <label
                htmlFor="formFile"
                className="form-label"
                style={{ marginBottom: 0 }}
              >
                Foto
              </label>
              <label htmlFor="inputImage" style={{ marginBottom: 0 }}>
                <i className="bx bx-pencil" style={{ cursor: "pointer" }} />
              </label>

              <input
                id="inputImage"
                type={"file"}
                onChange={(e) => {
                  onImageChange(e);
                }}
                style={{ display: "none" }}
              />
              {imageErro && <span className="text-danger">{imageErro}</span>}
            </Col>

            <Col sm={6} style={{ display: "flex", alignItems: "center" }}>
              {imageView && (
                <img alt="edit" src={imageView} style={{ width: 70 }} />
              )}
            </Col>
          </Row>

          <Row style={{ marginTop: 20, marginBottom: 20 }}>
            <Col md={6}>
              <div className="form-check form-check-end">
                <input
                  className="form-check-input"
                  type="checkbox"
                  checked={isVisible}
                  onChange={(e) => setIsVisible(e.target.checked)}
                />
                <label>Visível</label>
              </div>
            </Col>

            <Col md={6}>
              <div className="form-check form-check-end">
                <input
                  className="form-check-input"
                  type="checkbox"
                  checked={isFixed}
                  onChange={(e) => setIsFixed(e.target.checked)}
                />
                <label>Fixado</label>
              </div>
            </Col>
          </Row>

          <Row>
            <Col
              md={12}
              style={{
                width: "100%",
                margin: "auto",
                display: "flex",
                justifyContent: "flex-end",
              }}
            >
              <Button
                color="success"
                className="btn btn-danger waves-effect waves-light"
                style={{ width: 80 }}
                onClick={() => toggle()}
              >
                Fechar
              </Button>

              <ButtonSpinner
                isLoading={isLoading}
                title={"Salvar"}
                marginLeft={10}
                action="U"
              />
            </Col>
          </Row>
        </form>
      </ModalBody>
    </Modal>
  );
}

const mapStateToProps = function (state) {
  return { state: state };
};

export default connect(mapStateToProps)(EditFeed);
